import React, { useEffect, useState } from 'react'
import './Config.css'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import Categories from './category/Categories'
import SubCategory from './sub-category/SubCategory'
import Projects from './project/Projects'
import TabsTwo from '../../../components/general/general-component/tabs/TabsTwo'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'

function Config() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const [type, setType] = useState('categories')
    const handleSectionClick = (sectionId) => {
        setType(sectionId);
    };
    const tabs = [
        {
            id: 1,
            name: translate('categories'),
            type: 'categories',
            icon: 'fa-solid fa-border-all'
        },
        {
            id: 2,
            name: translate('sub_categories'),
            type: 'sub_categories',
            icon: 'fa-solid fa-border-top-left'
        },
    ]
    return (
        <>
            <div className='config-warehouse' >
                <TabsTwo langLocal={langLocal} tabs={tabs} activeSection={type} handleSectionClick={handleSectionClick} />

                <div className='config-warehouse-right'>
                    {
                        type === 'categories' && (
                            <Categories />
                        )
                    }
                    {
                        type === 'sub_categories' && (
                            <SubCategory />
                        )
                    }
                    {/*
                        type === 'projects' && (
                            <Projects />
                        )
                    */}
                </div>
            </div>
        </>

    )
}

export default Config